// Shared body regions for the gold-line figure studies (848×1264, same pose and framing for both figures).
export const BODY_SPOTS = [["crown", 50, 6.5], ["brow", 50, 11.5], ["throat", 50, 19], ["heart", 50, 27.5], ["solar", 50, 35], ["sacral", 50, 42], ["root", 50, 49], ["hands", 21.5, 52.5], ["hands", 78.5, 52.5], ["feet", 50, 92.5]];
export const POINT = Object.fromEntries(BODY_SPOTS.filter((s, i) => i !== 8).map(([k, x, y]) => [k, [x, y]]));
export const REGION_NAMES = { crown: "Crown", brow: "Third eye", throat: "Throat", heart: "Heart", solar: "Solar plexus", sacral: "Womb / sacral", root: "Root", hands: "Hands", feet: "Feet" };
export const figureSrc = (f) => `/images/gates-body-${f}.webp`;

const RISE = ["root", "sacral", "solar", "heart", "throat", "crown"];
const WORDS = [
  ["crown", /\bcrown\b|top of (?:the|your) head/g],
  ["brow", /third eye|\bbrow\b|forehead/g],
  ["throat", /\bthroat\b|\bjaw\b|\bmouth\b|\blips\b|\btongue\b/g],
  ["heart", /\bheart\b|\bchest\b|\bbreasts?\b|\bnipples?\b/g],
  ["solar", /solar plexus|\bbelly\b|\bnavel\b|\bdiaphragm\b|\bstomach\b/g],
  ["sacral", /\bwomb\b|\bsacral\b|\bsacrum\b|\bhara\b|lower (?:belly|abdomen)|\bprostate\b|\buterus\b|\bovaries\b/g],
  ["root", /\bperineum\b|pelvic floor|\bpelvis\b|\bpelvic\b|\broot\b|base of (?:the|your) spine|\byoni\b|\blingam\b|\bgenitals?\b|\bclitoris\b|\bvagina\b|\bvaginal\b|\bpenis\b|\bshaft\b|\btesticles\b|\bballs\b|\banus\b|\banal\b|\bcervix\b|g-spot/g],
  ["hands", /\bhands?\b|\bpalms?\b|\bfingers?\b|\bfingertips\b/g],
  ["feet", /\bfeet\b|\bfoot\b|\bsoles\b|\blegs?\b|\bthighs?\b|\btoes\b/g],
  ["spine", /\bspine\b|\bspinal\b/g],
];

// Body areas a text names, in the order the energy moves through them. "Spine" fills in the rising channel.
export const detectRegions = (text = "") => {
  const t = text.toLowerCase();
  const hits = [];
  WORDS.forEach(([k, re]) => {
    for (const m of t.matchAll(re)) hits.push([m.index, k]);
  });
  const out = [];
  hits.sort((a, b) => a[0] - b[0]).forEach(([, k]) => {
    (k === "spine" ? RISE : [k]).forEach((r) => !out.includes(r) && out.push(r));
  });
  return out;
};

// Figure preferences (Settings): one figure for solo practice, a pair for partner practice.
const KEY = "tt-figures";
export const FIGURE_SETS = { female: ["female"], male: ["male"], fm: ["female", "male"], mm: ["male", "male"], ff: ["female", "female"] };
export const FIGURE_LABELS = { female: "Female", male: "Male", fm: "Female + Male", mm: "Male + Male", ff: "Female + Female" };
export const getFigures = () => {
  try {
    return { solo: "female", pair: "fm", ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch {
    return { solo: "female", pair: "fm" };
  }
};
export const setFigures = (patch) => localStorage.setItem(KEY, JSON.stringify({ ...getFigures(), ...patch }));
